module.exports = __webpack_public_path__ + "assets/pdf/E08-cn-urban-rail-transport.08ab931c.pdf";